export enum MIXPANEL_EVENTS {
	CREATE_GAME = 'create-game',
	EXPORT_IDEAS = 'export-ideas',
	SUBMIT_IDEAS = 'submit-ideas',
}
